import "core-js/stable";
import "regenerator-runtime/runtime";
window.$ = require("jquery");
import "select2";
